import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_58: FaireProductEntity = {
  token: "legacy_prod_abbott-58",
  type: "product",
  name: 'Small Pomegranate Shaped Bowl 4.5" L',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/945d839f20ab029a7ae611939634735d938d6d00bc70d1af12de93452b222ee5.jpeg",
  priceDollars: 16,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
